import React from "react";
import { TextField, InputAdornment, Box } from "@mui/material";
import { CalendarToday } from "@mui/icons-material"; // You can use any icon
import Grid from "@mui/material/Grid";

const DateField = ({ label, name, value, onChange, grid = 3 }) => {
  return (
    <Grid item xs={3}>
      <TextField
        label={label}
        name={name}
        variant="standard"
        value={value}
        onChange={onChange ? onChange : undefined} // Conditionally apply onChange
        type="date" // Makes this a date input
        fullWidth
        InputProps={{
          shrink: true,
          startAdornment: (
            <InputAdornment position="start">
              <Box sx={{ color: "grey" }}>
                <CalendarToday /> {/* Icon */}
              </Box>
            </InputAdornment>
          ),
        }}
        sx={{
          // Label color
          "& .MuiInputLabel-root": { color: "grey" }, // Default label color
          "& .MuiInputLabel-root.Mui-focused": { color: "grey" }, // Focused label color

          // Underline colors
          "& .MuiInput-underline:before": { borderBottomColor: "grey" }, // Default underline color
          "& .MuiInput-underline:hover:before": { borderBottomColor: "grey" }, // Hover underline color
          "& .MuiInput-underline:after": { borderBottomColor: "grey" }, // Focused underline color
        }}
      />
    </Grid>
  );
};

export default DateField;
